import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import {
  CarouselLegendContainer,
  CarouselLegendContent,
  CarouselLegendTitle,
  CarouselLegendDescription
} from './styled';

import carousel01 from '../../assets/carousel-01.jpg';
import carousel02 from '../../assets/carousel-02.jpg';
import carousel03 from '../../assets/carousel-03.jpg';

export const HomeCarousel = () => {
  return (
    <Carousel
      autoPlay
      interval={4000}
      infiniteLoop
      showThumbs={false}
      showStatus={false}
    >
      <div>
        <img src={carousel01} alt="" />
      </div>
      <div>
        <img src={carousel02} alt="" />
        <CarouselLegendContainer>
          <CarouselLegendContent>
            <CarouselLegendTitle>
              Despache sua encomenda pela BRASPRESS
            </CarouselLegendTitle>
            <CarouselLegendDescription>
              A sua transportadora de encomendas em todo o Brasil
            </CarouselLegendDescription>
          </CarouselLegendContent>
        </CarouselLegendContainer>
      </div>
      <div>
        <img src={carousel03} alt="" />
      </div>
    </Carousel>
  );
};
